module.exports = __webpack_public_path__ + "img/back-0.8bb017a1.jpg";